export enum SyncResultStatusEnum {
  ERROR = 'ERROR',
  STOCK_VALIDATED = 'STOCK_VALIDATED',
  OK = 'OK',
  OK_RESET = 'OK_RESET',
  SENDING = 'SENDING',
  SUCCESS_WITH_PAYMENT_ERROR = 'SUCCESS_WITH_PAYMENT_ERROR',
}
